module.exports = __webpack_public_path__ + "img/pagination_btn_right_icon.469701e4.svg";